import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerRequestAction, routerNavigatedAction, routerCancelAction, routerErrorAction } from '@ngrx/router-store';
import { map } from 'rxjs/operators';
import { startLoading, stopLoading } from './loading.actions';

@Injectable()
export class LoadingEffects {

    // Start loading on router request
    startLoading$ = createEffect(() =>
        this.actions$.pipe(
            ofType(routerRequestAction),
            map(() => startLoading())
        )
    );

    // Stop loading on navigation end, cancel, or error
    stopLoading$ = createEffect(() =>
        this.actions$.pipe(
            ofType(routerNavigatedAction, routerCancelAction, routerErrorAction),
            map(() => stopLoading())
        )
    );

    constructor(private actions$: Actions) { }
}
